import { createContext, Context } from 'react';
import { AppContextInterface, PathContextInterface } from '../models/app';

/**
 * Initialize app context.
 */
export const PathContext = createContext<PathContextInterface>({
  pathname: '',
  querystring: {},
  path: '',
  host: '',
  originalPath: '',
  translatedPath: '',
});

/**
 * Information about the app to be shared (e.g. menus).
 */
export const AppContext: Context<AppContextInterface> = createContext({});
